<header
  class="display-none-while-printing relative z-5 h-[50px] flex px-[0px] sm:px-[34px] w-full bg-slate-50 dark:bg-slate-800"
>
  <nav class="w-full mx-auto flex">
    <a class="flex items-center py-[4px] active:opacity-80 hover:cursor-pointer" href="/">
      <svg
        class="w-[130px] text-gray-800 dark:text-gray-200"
        width="130"
        height="24"
        viewBox="0 0 130 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3.71508 0.5H35L31.2849 6.77273H0L3.71508 0.5Z" fill="#EF4444" />
        <path d="M3.71508 8.86328H35L31.2849 15.136H0L3.71508 8.86328Z" fill="#EF4444" />
        <path d="M3.71508 17.2275H35L31.2849 23.5003H0L3.71508 17.2275Z" fill="#EF4444" />
        <path
          d="M127.273 0.396484V3.12752H120.264V5.36697H126.673V7.98876H120.264V10.5195H127.437V13.3598H116.896V0.396484H127.273Z"
          fill="currentColor"
        />
        <path
          d="M111.747 8.29822H115.115C115.079 9.2996 114.969 9.68195 114.514 10.5923C113.495 12.6679 111.729 13.6693 109.161 13.6693C105.138 13.6693 102.68 10.7562 102.68 6.84167C102.68 2.85436 105.356 0.0869141 109.216 0.0869141C112.111 0.0869141 114.805 1.8894 115.042 4.96636H111.71C111.419 3.61905 110.545 2.92719 109.143 2.92719C107.286 2.92719 106.103 4.49298 106.103 6.9145C106.103 9.26319 107.304 10.7926 109.143 10.7926C110.636 10.7926 111.51 9.95505 111.747 8.29822Z"
          fill="currentColor"
        />
        <path
          d="M89.9043 13.3598V0.396484H96.6591C99.0988 0.396484 101.047 1.59814 101.047 4.1471C101.047 5.64007 100.373 6.71428 99.0442 7.3151C99.8635 7.58821 100.446 8.15262 100.683 8.99014C100.883 9.682 100.919 9.82766 101.083 11.7394C101.138 12.3402 101.138 12.8682 101.502 13.3598H98.061C97.7333 12.5769 97.7697 11.5027 97.6786 10.647C97.5148 9.11759 96.9322 8.53497 95.3664 8.53497H93.2908V13.3598H89.9043ZM93.2908 6.13166H95.6759C96.7865 6.13166 97.7151 5.89497 97.7151 4.52945C97.7151 3.50986 97.0414 3.01828 95.6395 3.01828H93.2908V6.13166Z"
          fill="currentColor"
        />
        <path
          d="M88.096 6.89629C88.096 10.7015 85.7109 13.6693 81.7782 13.6693C77.7727 13.6693 75.2783 10.829 75.2783 6.87809C75.2783 3.03643 77.8455 0.0869141 81.7418 0.0869141C85.6016 0.0869141 88.096 2.72691 88.096 6.89629ZM84.6367 6.78705C84.6367 4.32912 83.526 2.83616 81.7054 2.83616C79.8847 2.83616 78.7376 4.38374 78.7376 6.84167C78.7376 9.37243 79.8482 10.8836 81.7236 10.8836C83.5625 10.8836 84.6367 9.37243 84.6367 6.78705Z"
          fill="currentColor"
        />
        <path
          d="M74.1989 0.396484V3.21855H68.0268V5.7129H73.3796V8.37111H68.0268V13.3598H64.6221V0.396484H74.1989Z"
          fill="currentColor"
        />
        <path
          d="M62.5537 0.396484V3.12752H55.5441V5.36697H61.9529V7.98876H55.5441V10.5195H62.7176V13.3598H52.1758V0.396484H62.5537Z"
          fill="currentColor"
        />
        <path
          d="M39 13.3598V0.396484H45.7548C48.1945 0.396484 50.1426 1.59814 50.1426 4.1471C50.1426 5.64007 49.469 6.71428 48.1399 7.3151C48.9592 7.58821 49.5418 8.15262 49.7785 8.99014C49.9788 9.682 50.0152 9.82766 50.179 11.7394C50.2337 12.3402 50.2337 12.8682 50.5978 13.3598H47.1567C46.829 12.5769 46.8654 11.5027 46.7743 10.647C46.6105 9.11759 46.0279 8.53497 44.4621 8.53497H42.3865V13.3598H39ZM42.3865 6.13166H44.7716C45.8822 6.13166 46.8108 5.89497 46.8108 4.52945C46.8108 3.50986 46.1371 3.01828 44.7352 3.01828H42.3865V6.13166Z"
          fill="currentColor"
        />
        <path
          d="M128.021 19.7656V23.8167H127.133V21.006H127.116L125.591 23.8167H124.59V19.7656H125.477V22.5706H125.494L127.019 19.7656H128.021Z"
          fill="currentColor"
        />
        <path
          d="M124.007 19.7656V20.5223H122.79V23.8167H121.896V20.5223H120.679V19.7656H124.007Z"
          fill="currentColor"
        />
        <path
          d="M120.386 22.252C120.294 23.242 119.68 23.9134 118.571 23.9134C117.393 23.9134 116.613 23.0657 116.613 21.7855C116.613 20.6077 117.364 19.6689 118.605 19.6689C119.578 19.6689 120.289 20.2834 120.357 21.1198H119.487C119.396 20.676 119.066 20.4143 118.588 20.4143C117.808 20.4143 117.507 21.1141 117.507 21.7912C117.507 22.6276 117.922 23.1624 118.576 23.1624C119.111 23.1624 119.43 22.8438 119.504 22.252H120.386Z"
          fill="currentColor"
        />
        <path
          d="M114.056 19.6689C115.24 19.6689 116.042 20.5281 116.042 21.7969C116.042 23.06 115.24 23.9134 114.051 23.9134C112.85 23.9134 112.048 23.0657 112.048 21.7969C112.048 20.511 112.844 19.6689 114.056 19.6689ZM114.045 20.3972C113.374 20.3972 112.947 20.9377 112.947 21.7798C112.947 22.6503 113.368 23.1738 114.056 23.1795C114.728 23.1795 115.143 22.6446 115.143 21.7798C115.143 20.9264 114.722 20.3972 114.045 20.3972Z"
          fill="currentColor"
        />
        <path
          d="M111.324 19.7656V23.8167H110.437V22.0699H108.781V23.8167H107.894V19.7656H108.781V21.2905H110.437V19.7656H111.324Z"
          fill="currentColor"
        />
        <path
          d="M107.181 22.252C107.09 23.242 106.476 23.9134 105.366 23.9134C104.189 23.9134 103.409 23.0657 103.409 21.7855C103.409 20.6077 104.16 19.6689 105.401 19.6689C106.373 19.6689 107.085 20.2834 107.153 21.1198H106.282C106.191 20.676 105.861 20.4143 105.383 20.4143C104.604 20.4143 104.302 21.1141 104.302 21.7912C104.302 22.6276 104.718 23.1624 105.372 23.1624C105.907 23.1624 106.226 22.8438 106.3 22.252H107.181Z"
          fill="currentColor"
        />
        <path
          d="M101.568 19.7598L103.11 23.8165H102.177L101.858 22.9118H100.351L100.021 23.8165H99.1104L100.652 19.7598H101.568ZM101.642 22.2632L101.107 20.7555L100.567 22.2632H101.642Z"
          fill="currentColor"
        />
        <path
          d="M98.6535 19.7656V23.8167H97.7659V20.5223H96.1102V23.8167H95.2227V19.7656H98.6535Z"
          fill="currentColor"
        />
        <path
          d="M92.5124 19.6689C93.6958 19.6689 94.498 20.5281 94.498 21.7969C94.498 23.06 93.6958 23.9134 92.5067 23.9134C91.3061 23.9134 90.5039 23.0657 90.5039 21.7969C90.5039 20.511 91.3005 19.6689 92.5124 19.6689ZM92.501 20.3972C91.8296 20.3972 91.4029 20.9377 91.4029 21.7798C91.4029 22.6503 91.8239 23.1738 92.5124 23.1795C93.1837 23.1795 93.5991 22.6446 93.5991 21.7798C93.5991 20.9264 93.178 20.3972 92.501 20.3972Z"
          fill="currentColor"
        />
        <path
          d="M89.9498 22.571C89.9498 23.3562 89.2614 23.9081 88.3567 23.9081C87.2586 23.9081 86.61 23.3789 86.5986 22.4629H87.4805C87.4976 23.0091 87.8788 23.2253 88.3567 23.2253C88.7721 23.2253 89.0566 22.9465 89.0566 22.5767C89.0566 22.1158 88.6867 22.0077 88.2941 22.0077H87.9869V21.4046C88.0552 21.4103 88.1747 21.4103 88.2259 21.4103C88.7152 21.4103 88.9598 21.2112 88.9598 20.8584C88.9598 20.5455 88.7152 20.3691 88.351 20.3691C87.9129 20.3691 87.6341 20.5796 87.6 20.9722H86.7579C86.775 20.0676 87.5033 19.6807 88.3567 19.6807C89.176 19.6807 89.7962 20.1245 89.7962 20.8015C89.7962 21.2055 89.5459 21.5355 89.1817 21.6151C89.6198 21.6834 89.9498 22.0533 89.9498 22.571Z"
          fill="currentColor"
        />
        <path
          d="M86.1066 19.7656V20.4939H83.9503V21.3758H85.9303V22.0756H83.9503V23.0713H86.1465V23.8167H83.0684V19.7656H86.1066Z"
          fill="currentColor"
        />
        <path
          d="M79.8419 21.2222H80.9001C81.7138 21.2222 82.3396 21.6318 82.3396 22.5137C82.3396 23.407 81.7308 23.8167 80.8546 23.8167H78.96V19.7656H81.9641V20.4996H79.8419V21.2222ZM81.4748 22.5023C81.4748 22.0756 81.1789 21.922 80.7807 21.922H79.8419V23.0884H80.7863C81.2131 23.0884 81.4748 22.9348 81.4748 22.5023Z"
          fill="currentColor"
        />
        <path
          d="M75.2568 19.7598L76.7987 23.8165H75.8656L75.5469 22.9118H74.0392L73.7092 23.8165H72.7988L74.3407 19.7598H75.2568ZM75.3307 22.2632L74.7959 20.7555L74.2554 22.2632H75.3307Z"
          fill="currentColor"
        />
        <path
          d="M67.9668 23.8167V19.7656H69.2356L70.1801 22.5479L71.1018 19.7656H72.3421V23.8167H71.5058V20.9377L70.5101 23.8167H69.8216L68.8146 20.9661V23.8167H67.9668Z"
          fill="currentColor"
        />
        <path
          d="M64.0635 19.7656H65.8102C66.6864 19.7656 67.2952 20.1753 67.2952 21.0686C67.2952 21.9505 66.6693 22.3601 65.8557 22.3601H64.9454V23.8167H64.0635V19.7656ZM64.9454 20.4939V21.6603H65.7362C66.1345 21.6603 66.4304 21.5294 66.4304 21.0799C66.4304 20.6475 66.1345 20.4939 65.7419 20.4939H64.9454Z"
          fill="currentColor"
        />
        <path
          d="M61.3483 19.6689C62.5317 19.6689 63.334 20.5281 63.334 21.7969C63.334 23.06 62.5317 23.9134 61.3426 23.9134C60.1421 23.9134 59.3398 23.0657 59.3398 21.7969C59.3398 20.511 60.1364 19.6689 61.3483 19.6689ZM61.3369 20.3972C60.6655 20.3972 60.2388 20.9377 60.2388 21.7798C60.2388 22.6503 60.6598 23.1738 61.3483 23.1795C62.0197 23.1795 62.435 22.6446 62.435 21.7798C62.435 20.9264 62.014 20.3972 61.3369 20.3972Z"
          fill="currentColor"
        />
        <path
          d="M58.7957 21.7456C58.7957 22.7641 58.0788 23.333 57.0376 23.3729V23.8167H56.1614V23.3729C55.1202 23.333 54.4033 22.7641 54.4033 21.7456C54.4033 20.767 55.1031 20.198 56.1614 20.1639V19.7656H57.0376V20.1639C58.0959 20.198 58.7957 20.767 58.7957 21.7456ZM57.9423 21.7456C57.9423 21.171 57.6237 20.8296 57.0376 20.8068V22.7072C57.6066 22.6844 57.9423 22.2861 57.9423 21.7456ZM56.1614 22.7072V20.8068C55.5754 20.8296 55.2625 21.171 55.2625 21.7456C55.2625 22.2861 55.5925 22.6844 56.1614 22.7072Z"
          fill="currentColor"
        />
        <path
          d="M54.1468 19.7656V20.5223H52.9292V23.8167H52.0359V20.5223H50.8184V19.7656H54.1468Z"
          fill="currentColor"
        />
        <path
          d="M49.5654 19.7598L51.1072 23.8165H50.1741L49.8555 22.9118H48.3478L48.0178 23.8165H47.1074L48.6493 19.7598H49.5654ZM49.6393 22.2632L49.1045 20.7555L48.564 22.2632H49.6393Z"
          fill="currentColor"
        />
        <path
          d="M46.6711 19.7656V23.8167H45.7836V20.5223H44.6968L44.6399 22.2406C44.6001 23.3899 44.2075 23.8963 43.5134 23.8963C43.3541 23.8963 43.1322 23.8679 43.0127 23.828V23.1111C43.081 23.1453 43.2118 23.1794 43.3256 23.1794C43.5646 23.1794 43.758 23.0599 43.7808 22.2292L43.8491 19.7656H46.6711Z"
          fill="currentColor"
        />
        <path
          d="M42.4309 19.7656V23.8167H41.5433V20.5223H39.8876V23.8167H39V19.7656H42.4309Z"
          fill="currentColor"
        />
      </svg>
    </a>
    <section class="h-full flex gap-[8px] items-center justify-end py-[4px] overflow-hidden grow">
      <div
        class="hs-dropdown [--strategy:static] sm:[--strategy:fixed] [--adaptive:none] sm:[--adaptive:adaptive]"
      >
        <button
          [ngClass]="{
            'bg-gray-200 dark:bg-gray-700':
              window.location.pathname === '/departures' ||
              window.location.pathname === '/departure-history',
          }"
          type="button"
          class="hs-dropdown-toggle cursor-pointer roboto-medium-sm flex rounded-lg items-center w-full text-gray-800 dark:text-gray-200 py-[8px] px-[12px] text-navbar-nav-foreground hover:text-primary-hover focus:outline-hidden focus:text-primary-focus"
          aria-haspopup="menu"
          aria-expanded="false"
          aria-label="Mega Menu"
        >
          @if (window.location.pathname === '/departure-history') {
            История выездов
          } @else if (window.location.pathname === '/statistics') {
            Статистика
          } @else {
            Выезды
          }
          <svg
            class="hs-dropdown-open:-rotate-180 sm:hs-dropdown-open:rotate-0 duration-300 ms-1 shrink-0 size-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>

        <div
          class="hs-dropdown-menu transition-[opacity,margin] ease-in-out duration-[150ms] hs-dropdown-open:opacity-100 opacity-0 bg-white dark:bg-gray-800 z-10 sm:bg-dropdown sm:shadow-md rounded-xl flex flex-col gap-y-[10px] p-[12px] before:absolute top-full before:-top-5 before:start-0 before:w-full before:h-5 hidden w-[225px] top-[9px]"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="hs-navbar-example-dropdown"
        >
          <a
            [routerLink]="'departures'"
            routerLinkActive="active-page"
            [ngClass]="{
              'bg-white hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200':
                window.location.pathname !== '/departures',
              'bg-red-500 dark:bg-red-600 hover:bg-red-400 dark:hover:bg-red-500 text-white':
                window.location.pathname === '/departures',
            }"
            class="flex items-center gap-x-3.5 py-[8px] pl-[12px] rounded-lg roboto-medium-sm text-dropdown-item-foreground hover:bg-dropdown-item-hover focus:outline-hidden focus:bg-dropdown-item-focus"
            href="#"
          >
            Выезды
          </a>
          <a
            [routerLink]="'departure-history'"
            routerLinkActive="active-page"
            [ngClass]="{
              'bg-white hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200':
                window.location.pathname !== '/departure-history',
              'bg-red-500 dark:bg-red-600 hover:bg-red-400 dark:hover:bg-red-500 text-white':
                window.location.pathname === '/departure-history',
            }"
            class="flex items-center gap-x-3.5 py-[8px] pl-[12px] rounded-lg roboto-medium-sm text-dropdown-item-foreground text-gray-800 hover:bg-dropdown-item-hover focus:outline-hidden focus:bg-dropdown-item-focus"
            href="#"
          >
            История выездов
          </a>
          <a
            [routerLink]="'statistics'"
            routerLinkActive="active-page"
            [ngClass]="{
              'bg-white hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200':
                window.location.pathname !== '/statistics',
              'bg-red-500 dark:bg-red-600 hover:bg-red-400 dark:hover:bg-red-500 text-white':
                window.location.pathname === '/statistics',
            }"
            class="flex items-center gap-x-3.5 py-[8px] pl-[12px] rounded-lg roboto-medium-sm text-dropdown-item-foreground hover:bg-dropdown-item-hover focus:outline-hidden focus:bg-dropdown-item-focus"
            href="#"
          >
            Статистика
          </a>
        </div>
      </div>
      <div
        class="hs-dropdown [--strategy:static] sm:[--strategy:fixed] [--adaptive:none] sm:[--adaptive:adaptive]"
      >
        <button
          [ngClass]="{
            'bg-gray-200 dark:bg-gray-700':
              window.location.pathname === '/missions' ||
              window.location.pathname === '/mission-history' ||
              window.location.pathname === '/mission-configurator' ||
              window.location.pathname === '/mission-statistics',
          }"
          type="button"
          class="hs-dropdown-toggle cursor-pointer roboto-medium-sm flex rounded-lg items-center w-full text-gray-800 dark:text-gray-200 py-[8px] px-[12px] text-navbar-nav-foreground hover:text-primary-hover focus:outline-hidden focus:text-primary-focus"
          aria-haspopup="menu"
          aria-expanded="false"
          aria-label="Mega Menu"
        >
          @if (window.location.pathname === '/mission-history') {
            История миссий
          } @else if (window.location.pathname === '/mission-configurator') {
            Управление миссиями
          } @else if (window.location.pathname === '/mission-statistics') {
            Статистика
          } @else {
            Миссии
          }
          <svg
            class="hs-dropdown-open:-rotate-180 sm:hs-dropdown-open:rotate-0 duration-300 ms-1 shrink-0 size-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>

        <div
          class="hs-dropdown-menu transition-[opacity,margin] ease-in-out duration-[150ms] hs-dropdown-open:opacity-100 opacity-0 bg-white dark:bg-gray-800 z-10 sm:bg-dropdown sm:shadow-md rounded-xl flex flex-col gap-y-[10px] p-[12px] before:absolute top-full before:-top-5 before:start-0 before:w-full before:h-5 hidden w-[225px] top-[9px]"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="hs-navbar-example-dropdown"
        >
          <a
            [routerLink]="'missions'"
            routerLinkActive="active-page"
            [ngClass]="{
              'bg-white hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200':
                window.location.pathname !== '/missions',
              'bg-red-500 dark:bg-red-600 hover:bg-red-400 dark:hover:bg-red-500 text-white':
                window.location.pathname === '/missions',
            }"
            class="flex items-center gap-x-3.5 py-[8px] pl-[12px] rounded-lg roboto-medium-sm text-dropdown-item-foreground hover:bg-dropdown-item-hover focus:outline-hidden focus:bg-dropdown-item-focus"
            href="#"
          >
            Миссии
          </a>
          <a
            [routerLink]="'mission-history'"
            routerLinkActive="active-page"
            [ngClass]="{
              'bg-white hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200':
                window.location.pathname !== '/mission-history',
              'bg-red-500 dark:bg-red-600 hover:bg-red-400 dark:hover:bg-red-500 text-white':
                window.location.pathname === '/mission-history',
            }"
            class="flex items-center gap-x-3.5 py-[8px] pl-[12px] rounded-lg roboto-medium-sm text-dropdown-item-foreground hover:bg-dropdown-item-hover focus:outline-hidden focus:bg-dropdown-item-focus"
            href="#"
          >
            История миссий
          </a>
          <a
            [routerLink]="'mission-configurator'"
            routerLinkActive="active-page"
            [ngClass]="{
              'bg-white hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200':
                window.location.pathname !== '/mission-configurator',
              'bg-red-500 dark:bg-red-600 hover:bg-red-400 dark:hover:bg-red-500 text-white':
                window.location.pathname === '/mission-configurator',
            }"
            class="flex items-center gap-x-3.5 py-[8px] pl-[12px] rounded-lg roboto-medium-sm text-dropdown-item-foreground hover:bg-dropdown-item-hover focus:outline-hidden focus:bg-dropdown-item-focus"
            href="#"
          >
            Управление миссиями
          </a>
          <a
            [routerLink]="'mission-statistics'"
            routerLinkActive="active-page"
            [ngClass]="{
              'bg-white hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200':
                window.location.pathname !== '/mission-statistics',
              'bg-red-500 dark:bg-red-600 hover:bg-red-400 dark:hover:bg-red-500 text-white':
                window.location.pathname === '/mission-statistics',
            }"
            class="flex items-center gap-x-3.5 py-[8px] pl-[12px] rounded-lg roboto-medium-sm text-dropdown-item-foreground hover:bg-dropdown-item-hover focus:outline-hidden focus:bg-dropdown-item-focus"
            href="#"
          >
            Статистика
          </a>
        </div>
      </div>
      <div
        class="hs-dropdown [--strategy:static] sm:[--strategy:fixed] [--adaptive:none] sm:[--adaptive:adaptive]"
      >
        <button
          [ngClass]="{
            'bg-gray-200 dark:bg-gray-700':
              window.location.pathname === '/team-shift-changes-history' ||
              window.location.pathname === '/teams-summary',
          }"
          type="button"
          class="hs-dropdown-toggle cursor-pointer roboto-medium-sm flex rounded-lg items-center w-full text-gray-800 dark:text-gray-200 py-[8px] px-[12px] text-navbar-nav-foreground hover:text-primary-hover focus:outline-hidden focus:text-primary-focus"
          aria-haspopup="menu"
          aria-expanded="false"
          aria-label="Mega Menu"
        >
          @if (window.location.pathname === '/team-shift-changes-history') {
            История пересменок
          } @else if (window.location.pathname === '/teams-summary') {
            Сводка по группам
          } @else {
            Пересменки
          }

          @if (pendingRequestsCount() !== 0) {
            <span
              class="ml-[8px] h-[18px] inline-flex items-center py-[1px] px-[5.5px] rounded-full roboto-medium-xxs bg-red-100 text-red-800 dark:bg-red-800/30 dark:text-red-500"
            >
              {{ pendingRequestsCount() }}
            </span>
          }
          <svg
            class="hs-dropdown-open:-rotate-180 sm:hs-dropdown-open:rotate-0 duration-300 ms-1 shrink-0 size-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>

        <div
          class="hs-dropdown-menu transition-[opacity,margin] ease-in-out duration-[150ms] hs-dropdown-open:opacity-100 opacity-0 bg-white dark:bg-gray-800 z-10 sm:bg-dropdown sm:shadow-md rounded-xl flex flex-col gap-y-[10px] p-[12px] before:absolute top-full before:-top-5 before:start-0 before:w-full before:h-5 hidden w-[225px] top-[9px]"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="hs-navbar-example-dropdown"
        >
          <a
            [routerLink]="'team-shift-changes-history'"
            routerLinkActive="active-page"
            [ngClass]="{
              'bg-white hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200':
                window.location.pathname !== '/team-shift-changes-history',
              'bg-red-500 dark:bg-red-600 hover:bg-red-400 dark:hover:bg-red-500 text-white':
                window.location.pathname === '/team-shift-changes-history',
            }"
            class="flex items-center gap-x-3.5 py-[8px] pl-[12px] rounded-lg roboto-medium-sm text-dropdown-item-foreground hover:bg-dropdown-item-hover focus:outline-hidden focus:bg-dropdown-item-focus"
            href="#"
          >
            История пересменок
            @if (pendingRequestsCount() !== 0) {
              <span
                class="h-[18px] inline-flex items-center py-[1px] px-[5.5px] rounded-full roboto-medium-xxs bg-red-100 text-red-800 dark:bg-red-800/30 dark:text-red-500"
              >
                {{ pendingRequestsCount() }}
              </span>
            }
          </a>
          <a
            [routerLink]="'teams-summary'"
            routerLinkActive="active-page"
            [ngClass]="{
              'bg-white hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200':
                window.location.pathname !== '/teams-summary',
              'bg-red-500 dark:bg-red-600 hover:bg-red-400 dark:hover:bg-red-500 text-white':
                window.location.pathname === '/teams-summary',
            }"
            class="flex items-center gap-x-3.5 py-[8px] pl-[12px] rounded-lg roboto-medium-sm text-dropdown-item-foreground hover:bg-dropdown-item-hover focus:outline-hidden focus:bg-dropdown-item-focus"
            href="#"
          >
            Сводка по группам
          </a>
        </div>
      </div>
      <div class="h-[24px] border-s border-gray-200 dark:border-white/20"></div>
      <button
        (click)="changeTheme('dark')"
        type="button"
        class="hs-dark-mode-active:hidden cursor-pointer ml-[12px] mr-[8px] block hs-dark-mode text-gray-500 rounded-lg hover:text-red-500"
        data-hs-theme-click-value="dark"
      >
        <span class="group inline-flex shrink-0 justify-center items-center size-9">
          <svg
            class="shrink-0 size-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"></path>
          </svg>
        </span>
      </button>
      <button
        (click)="changeTheme('light')"
        type="button"
        class="hs-dark-mode-active:block hidden cursor-pointer ml-[12px] mr-[8px] hs-dark-mode rounded-lg dark:text-white dark:hover:text-red-500"
        data-hs-theme-click-value="light"
      >
        <span class="group inline-flex shrink-0 justify-center items-center size-9">
          <svg
            class="shrink-0 size-4"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="4"></circle>
            <path d="M12 2v2"></path>
            <path d="M12 20v2"></path>
            <path d="m4.93 4.93 1.41 1.41"></path>
            <path d="m17.66 17.66 1.41 1.41"></path>
            <path d="M2 12h2"></path>
            <path d="M20 12h2"></path>
            <path d="m6.34 17.66-1.41 1.41"></path>
            <path d="m19.07 4.93-1.41 1.41"></path>
          </svg>
        </span>
      </button>
      <section class="hs-dropdown relative inline-flex">
        <button
          type="button"
          id="hs-dropdown-default"
          aria-haspopup="menu"
          aria-expanded="false"
          aria-label="Dropdown"
          class="hs-dropdown-toggle h-full flex gap-x-[8px] ml-[-12px] w-[111px] py-[10px] px-[12px] rounded-lg justify-center inline-flex border border-gray-200 dark:border-gray-700 bg-white dark:bg-slate-900 hover:bg-slate-50 dark:hover:bg-gray-700 items-center text-gray-500 dark:text-white hover:text-red-500 dark:hover:text-red-500 cursor-pointer"
        >
          <lucide-icon
            class="w-[14px] h-[14px] text-gray-800 dark:text-inherit"
            [img]="userIcon"
          ></lucide-icon>
          <p class="roboto-medium-sm text-gray-800 dark:text-inherit">Профиль</p>
        </button>
        <section
          class="z-1 hs-dropdown-menu transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden w-[234px] p-[8px] shadow-md rounded-lg mt-[4px]! bg-white dark:bg-gray-800 dark:border dark:border-gray-700 t-[18px]!"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="hs-dropdown-default"
        >
          @if (userLogin) {
            <section
              class="bg-gray-100 dark:bg-gray-800 -mx-[8px] -mt-[8px] px-[8px] py-[8px] rounded-t-lg overflow-hidden"
            >
              <section class="flex gap-x-[10px] bg-gray-100 dark:bg-gray-800">
                <section
                  class="flex items-center justify-center w-[38px] h-[38px] min-w-[38px] min-h-[38px] shadow-sm dark:shadow-none border border-gray-200 dark:border-gray-700 rounded-full"
                >
                  <p class="roboto-semi-bold-sm text-gray-800 dark:text-gray-200">
                    {{ userInitial }}
                  </p>
                </section>
                <section>
                  <p class="roboto-regular-sm text-gray-500 dark:text-gray-400">Авторизован как</p>
                  <p class="roboto-medium-sm text-gray-800 dark:text-gray-200 break-all">
                    {{ userLogin }}
                  </p>
                </section>
              </section>
            </section>
          }
          <button
            (click)="logout()"
            class="cursor-pointer w-full p-[8px] pt-[8px] gap-x-[12px] flex items-center rounded-lg focus:outline-hidden hover:text-red-500 dark:hover:text-red-500 text-gray-800 dark:text-gray-200 dark:active:text-red-500"
            [ngClass]="{ 'pt-[16px]': userLogin }"
          >
            <lucide-icon
              class="mb-[2px] w-[16px] h-[16px] dark:text-inherit"
              [img]="logOutIcon"
            ></lucide-icon>
            <p class="roboto-medium-sm text-inherit dark:text-inherit">Выход</p>
          </button>
        </section>
      </section>
    </section>
  </nav>
</header>

@if (navbarHeight() === 90) {
  <section
    class="h-[40px] w-full flex bg-red-500/50 text-gray-50 items-center justify-center roboto-regular gap-x-[24px]"
  >
    <h5>Сессия авторизации истекла. Перезайдите в аккаунт</h5>
    <button class="roboto-medium cursor-pointer hover:text-red-200" (click)="logout()">
      Выйти
    </button>
  </section>
}
